import {Query} from '@datorama/akita';
import {Injectable} from '@angular/core';
import {OperationListState, OperationListStore} from './operation-list.store';
import {ISavedListSettingsQuery} from '../../interfaces/settings/saved-list-settings.query';
import {TableColumn} from '../../models/table-column';
import {
  getOperationFilterOptions,
  getTableColumns,
} from './operation-table-columns';

@Injectable({
    providedIn: 'root',
})
export class OperationListQuery extends Query<OperationListState> implements ISavedListSettingsQuery {
    columns$;
    filterOptions$;
    filterValue$;

    constructor(protected store: OperationListStore) {
        super(store);

        this.columns$ = this.select((state) => state.columns);
        this.filterOptions$ = this.select((state) => state.filterOptions);
        this.filterValue$ = this.select((state) => state.filterValue);
    }

    filterOptions(): any {
        return this.store.getValue()?.filterOptions;
    }

    getFilterColumns(): TableColumn[] {
        return null;
    }

    getInitialColumns(): TableColumn[] {
        return getTableColumns();
    }

    getTableColumns(): TableColumn[] {
        return this.store.getValue()?.columns;
    }

    newFilterStructure(): boolean {
        return false;
    }

    getInitialFilter(): any {
        return getOperationFilterOptions();
    }

    hasFilter(): boolean {
        return true;
    }

}
